const Authorize = () => {
    //const codeChallenge = '0wAP7J05t0Pwpzsh8huSaTb4p2kuAAZwbhlVefHf0Eg';
    //const codeVerifier = localStorage.getItem('code_Verifier');
    const stateKey = localStorage.getItem('State');
    const codeChallenge = sessionStorage.getItem('code_Challenge');
    //return `http://localhost:9000/oauthsrvr/oauth2/authorize?response_type=code&client_id=admin&scope=openid&redirect_uri=http://127.0.0.1:3000/admin/auth&code_challenge=${codeChallenge}&state=${stateKey}&code_challenge_method=S256`
    return `https://www.enearmart.com/oauthsrvr/oauth2/authorize?response_type=code&client_id=admin&scope=openid&redirect_uri=https://www.enearmart.com/admin/auth&code_challenge=${codeChallenge}&state=${stateKey}&code_challenge_method=S256`
}

export default Authorize;